import { render, staticRenderFns } from "./Fachliste.vue?vue&type=template&id=19a266a4"
import script from "./Fachliste.vue?vue&type=script&lang=js"
export * from "./Fachliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports